import BookItem from "../common/bookItem";
// import { mouseEvent } from "../common/mouse_event";
// import AfilePageCount from "./afile_page_count";
export default class AfileChangePage extends BookItem {
    // afilePageCount = null;
    constructor(el, target) {
        super(el, target);
        /**
         * 按鈕換頁類型
         */
        this.changeFrameType = this.el.changeFrameType;
        
        /**
         * 按鈕目標影格，上下頁不需填
         * 
         * -1 處理影格實際數字
         */
        this.targetFrame = this.el.targetFrame - 1;

        // 美術填寫防呆
        if (this.changeFrameType == "指定目標") {
            if (this.el.targetFrame == null) {
                this.targetFrame = null;
                console.warn("指定目標影格沒有填!!!!");
            }
            else {
                this.targetFrame = this.el.targetFrame - 1;
            }
        }
        else {
            this.targetFrame = null;
        }

        /**
         * 按鈕的parent
         */
        this.targetMother = this.target.parent;

        /**
         * 指定目標類型按鈕群組
         */
        this.numBtnList = [];

        /**
         * 上下頁類型按鈕群組
         * 
         * 目前用於紀錄nowIndex使用
         */
        this.turnPageBtnList = [];
        /**
         * 開啟A檔初始實際影格位置
         */
        this.startFrame = this.target.stage.startFrame;
        // 需要知道當初開啟A檔填寫的起始影格值 this.startFrame
        // this.startFrame = 0;

        /**
         * 當前頁碼數字
         */
        this.nowIndex = null;

        this.add_mouse_event();
    }

    init() {
        let changePageBtn = this.itemControl.getItemsByClassName("afileChangePage", this);

        //抓指定目標類型
        changePageBtn.forEach(element => {
            if (element.changeFrameType == "指定目標") {
                this.numBtnList.push(element);
            }
            else {
                this.turnPageBtnList.push(element);
            }
        });
        
        // 需要知道當初開啟A檔填寫的起始影格值 this.startFrame
        
        if (this.targetFrame == this.targetMother.currentFrame - this.startFrame) {
            this.target.mouseEnabled = false;
            this.target.gotoAndStop(1);
            this.turnPageBtnList.forEach(element => {
                element.nowIndex = this.targetFrame;
            });
        }else {
            this.target.mouseEnabled = true;
        }

        // 排個順序
        this.numBtnList.sort(function (a, b) {
            return a.targetFrame - b.targetFrame
        })
    }

    trigger() {
        this.numBtnList.forEach(element => {
            element.target.mouseEnabled = true;
            element.target.gotoAndStop(0);
        });

        switch (this.changeFrameType) {
            case "上一頁":
                // 是第一頁那不做事
                if (this.targetMother.currentFrame == 0) {
                    // console.log("翻啥呢?")
                    return;
                }
                // console.log("上一頁");

                this.numBtnList[this.nowIndex].target.gotoAndStop(0);
                this.nowIndex--;
                this.numBtnList[this.nowIndex].target.gotoAndStop(1);

                this.ChangePageIndex(this.targetMother.currentFrame - 1);
                break;
            case "下一頁":
                //是最後一頁那不做事
                if (this.targetMother.currentFrame == this.targetMother.totalFrames - 1) {
                    // console.log("翻啥呢?")
                    return;
                }
                // console.log("下一頁");
                this.numBtnList[this.nowIndex].target.gotoAndStop(0);
                this.nowIndex++;
                this.numBtnList[this.nowIndex].target.gotoAndStop(1);

                this.ChangePageIndex(this.targetMother.currentFrame + 1);
                break;
            case "指定目標":
                //當前點的點過後不能點
                this.target.gotoAndStop(1);

                this.ChangePageIndex(this.startFrame + this.targetFrame);
                break;
        }
    }

    /**
     * 換頁設定
     * @param {*} index A檔跳至影格
     */
    ChangePageIndex(index) {
        this.itemControl.clearItems();
        //改a檔影格至點擊後該去的影格
        this.targetMother.gotoAndStop(index);
        //reinit
        this.itemControl.reInitStage();
        //svg
        const self = this;
        setTimeout(() => {
            self.itemControl.loader.loadBackground(index);
        });
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        //先移除再重掛上
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
            this.itemControl.loader.singleAntialiasing(this.target);
        });
    }
}